<template>
  <pod-editor/>
</template>

<script setup>
  import PodEditor from './PodEditor.vue'
</script>

<style>
  #app {
    font-family: Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html, body, #app {
    height: 100%;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }
</style>
